import React from "react";
import { getLibelleByIdInIIdLibelle, isNumeric, typeDemandeMessageListNotices } from "../../config/helpers";

interface IProps {
  Item?: string;
}

const HtmlRenderTypeDemandeNoticeMessage: React.FC<IProps> = ({ Item }) => {
  return (
    <span >
      {" "}
      {Item && isNumeric(Item) && getLibelleByIdInIIdLibelle(Number(Item),typeDemandeMessageListNotices)}
    </span>
  );
};

export default HtmlRenderTypeDemandeNoticeMessage;
